import { pdsTv } from '@purinanbm/pds-ui';
import { Link as GatsbyLink } from 'gatsby';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CMS_THEME } from 'src/common/enums';
import { Link } from '../Link';
import { CmsButtonLink } from '../button/CmsButton';

const body = pdsTv({
  slots: {
    imageLink: 'pds-box-border pds-block pds-rounded  pds-p-4 pds-mix-blend-multiply ',
    brand: 'pds-mt-4 pds-text-body-xs pds-uppercase pds-tracking-wider',
  },
  variants: {
    theme: {
      light: {
        imageLink: 'pds-bg-surface-layer',
        brand: 'pds-text-neutral',
      },
      dark: {
        imageLink: 'pds-bg-image-matte-dark',
        brand: 'pds-text-neutral-text',
      },
      neutral: {
        imageLink: 'pds-bg-surface-layer',
        brand: 'pds-text-neutral-text',
      },
    },
  },
});

interface Props {
  image: IGatsbyImageData;
  link: string;
  title: string;
  sku: string;
  cmsTheme: CMS_THEME;
  brand?: string;
  onClick?: () => void;
}

const OfferCardBody: React.FC<Props> = ({
  cmsTheme = CMS_THEME.LIGHT,
  link,
  image,
  onClick,
  brand,
  title,
  sku,
}) => {
  const { t } = useTranslation();
  const isExternalLink = link.includes('http');
  const slots = useMemo(() => body({ theme: cmsTheme }), [cmsTheme]);

  return (
    <>
      <GatsbyLink
        to={link}
        onClick={onClick}
        className={slots.imageLink()}
        target={isExternalLink ? '_blank' : undefined}
        aria-label={title}
      >
        <GatsbyImage image={image} objectFit="contain" alt="" style={{ maxHeight: '400px' }} />
      </GatsbyLink>
      {brand && <div className={slots.brand()}>{brand}</div>}
      <Link
        theme={cmsTheme}
        to={link}
        onClick={onClick}
        target={isExternalLink ? '_blank' : undefined}
        analytics={false}
        tabIndex={-1}
        className="pds-mb-2 pds-text-body-md pds-no-underline hover:pds-underline focus:pds-underline active:pds-underline"
        aria-hidden
        id={sku}
      >
        {title}
      </Link>
      <div className="pds-grow" />
      <div className="pds-mt-5">
        {/* // TODO: replace with button Link */}
        <CmsButtonLink
          to={link}
          width="full"
          onClick={onClick}
          aria-label={`${t('Redeem Offer')} ${title}`}
          cmsTheme={cmsTheme}
        >
          {t('Redeem Offer')}
        </CmsButtonLink>
      </div>
    </>
  );
};

export default OfferCardBody;
